// @ts-nocheck
import * as React from "react";

const ShareLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M18 15a3 3 0 0 0-2.1.86L8 12.34v-.67l7.9-3.53A3 3 0 1 0 15 6v.34L7.1 9.86a3 3 0 1 0 0 4.28l7.9 3.53V18a3 3 0 1 0 3-3Zm0-10a1 1 0 1 1-1 1 1 1 0 0 1 1-1ZM5 13a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm13 6a1 1 0 1 1 1-1 1 1 0 0 1-1 1Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(ShareLine);
